import React from 'react'
import { last, startCase } from 'lodash'
import { Control, Errors } from 'react-redux-form'
import { Form } from 'semantic-ui-react'
import 'semantic-ui-css/components/form.css'

export default class Field extends React.Component {
  render() {
    let {
      type = 'text',
      model,
      label,
      required,
      placeholder,
      children,
      plain,
      style,
      parser,
    } = this.props

    if (!label) label = startCase(last(model.split('.')))

    const inputTypes = ['text', 'select', 'textarea', 'checkbox']
    const subTypes = ['email']

    let inputType = 'text';
      let subType

    const types = type.split('.')
    types.forEach(lookupType => {
      if (inputTypes.includes(lookupType)) inputType = lookupType
      else if (subTypes.includes(lookupType)) subType = lookupType
    })

    const ControlComponent = Control[inputType]

    return (
      <Form.Field>
        {!plain && <label>{label}</label>}
        <ControlComponent
          {...(subType && { type: subType })}
          parser={parser}
          style={style}
          model={model}
          placeholder={placeholder}
          required={required}
          validateOn="blur"
        >
          {children}
        </ControlComponent>
        {!plain && (
          <div className="ui error message">
            <Errors
              className="content"
              component="p"
              model={model}
              show="touched"
              messages={{
                valueMissing: `${label} is required`,
                typeMismatch: `Invalid ${label}`,
              }}
            />
          </div>
        )}
      </Form.Field>
    )
  }
}
